import styled from 'styled-components';
import { Typography } from '@mui/material';

import colors from '../../../styles/colors';
import ColoredHeader from '../../components/ColoredHeader';

const Title = styled(Typography)`
  font-weight: bold;
  font-size: 24px;
  margin-bottom: 30px;
`;

const StyledHeader = styled(ColoredHeader)`
  height: auto;

  &:after {
    display: none;
  }
`;

const OptionContainer = styled.div`
  display: flex;
  flex-direction: row;
  gap: 20px;
  align-items: flex-end;
`;

const SelectWrapper = styled.div`
  width: 300px;
  display: flex;
  flex-direction: column;
`;

const DataGridContainer = styled.div`
  height: calc(100vh - 200px);
  width: 100%;
  padding: 15px 30px;
`;

const AddedText = styled.span`
  background-color: ${colors.base.primary};
  color: ${colors.base.secondary2};
  padding: 2px 4px;
  border-radius: 3px;
  font-weight: 500;
`;

const DeletedText = styled.span`
  background-color: ${colors.shades.danger2};
  color: ${colors.shades.danger3};
  padding: 2px 4px;
  border-radius: 3px;
  font-weight: 500;
  text-decoration: line-through;
`;

const ScrollableCell = styled.div`
  height: 100%;
  display: flex;
  align-items: center;
`;

const ScrollableCellContent = styled.div`
  max-height: calc(100% - 16px);
  overflow-y: auto;
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
  word-break: break-word;
  width: 100%;
`;

const MedianContainer = styled.div`
  padding: 15px 30px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  width: 100%;
`;

const MedianInfoWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

const MedianLabel = styled(Typography)`
  font-weight: 600;
  font-size: 16px;
  color: ${colors.base.beta};
`;

const MedianValue = styled(Typography)`
  font-weight: bold;
  font-size: 18px;
  color: ${colors.base.secondary2};
`;

export {
  Title,
  StyledHeader,
  OptionContainer,
  SelectWrapper,
  DataGridContainer,
  AddedText,
  DeletedText,
  ScrollableCell,
  ScrollableCellContent,
  MedianContainer,
  MedianInfoWrapper,
  MedianLabel,
  MedianValue,
};
